import { useEffect, useState } from "react";

export type ClientLevel = {
    id?: string;
    name: string;
    display_name?: string;
    client_id?: string;
    secret_key?: string;
    install_first_agent?: boolean;
};

const STORAGE_KEY = "level";
const EVENT_NAME = "client-level-changed";

export function getStoredLevel(): ClientLevel {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return { name: "global" };

    try {
        const parsed = JSON.parse(stored);
        if (parsed && typeof parsed.name === "string") {
            return parsed;
        }
        return { name: "global" };
    } catch {
        return { name: "global" };
    }
}

export function setStoredLevel(level: ClientLevel) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(level));
    // Custom event so all listeners in this tab update immediately
    window.dispatchEvent(new CustomEvent<ClientLevel>(EVENT_NAME, { detail: level }));
}

export function useClientLevel() {
    const [level, setLevel] = useState<ClientLevel>(() => getStoredLevel());

    useEffect(() => {
        const handler = (e: Event) => {
            const ev = e as CustomEvent<ClientLevel>;
            if (ev.detail) {
                setLevel(ev.detail);
            } else {
                setLevel(getStoredLevel());
            }
        };

        window.addEventListener(EVENT_NAME, handler);
        return () => window.removeEventListener(EVENT_NAME, handler);
    }, []);

    return level;
}
